<template>
  <BaseModal ref="modal">
    <UiModalDialog
      class="jps-modal"
      dialog-width="40rem"
      dialog-max-height="40rem"
    >
      <template #header>
        {{ ls({ ja: 'インポート', en: 'Import' }) }}
      </template>
      <div class="jps-modal-content">
        <BaseUpload
          accept="application/json"
          v-model="file"
          :message="{
            ja: 'エクスポートしたJSONファイルからノートを取り込むことができます。',
            en: 'Import mynote from exported JSON file',
          }"
        />
      </div>
      <template #buttons>
        <button @click="modal.reject()">{{ ls(dapLangGlobal.close) }}</button>
        <button @click="resolve()" :disabled="!file">{{ ls(dapLangGlobal.ok) }}</button>
      </template>
    </UiModalDialog>
  </BaseModal>
</template>

<script lang="ts" setup>
import { dapLangGlobal } from '#imports'
import type { BaseModal } from '#components'

const { ls } = useI18n()

const file = ref(null)

const modal = ref<InstanceType<typeof BaseModal>>()
const openAwait = async () => {
  file.value = null
  return await modal.value.openAwait<Curation>()
}
defineExpose({ openAwait })

const resolve = () => {
  if (file.value && file.value.length > 0) {
    const fileReader = new FileReader()
    fileReader.onload = () => {
      const curation: Curation = JSON.parse(fileReader.result as string)
      modal.value.resolve(curation)
    }
    fileReader.readAsText(file.value[0])
  }
}
</script>
